var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row py-3"},_vm._l((_vm.filteredList),function(value,index){return _c('div',{key:index,staticClass:"col-4"},[_c('router-link',{staticClass:"surah",attrs:{"to":{
            name: 'SurahId',
            params: {id: _vm.nPage[value.number - 1]},
          }}},[_c('div',[_vm._v(" "+_vm._s(value.number)+". "+_vm._s(value.name.split(' ').slice(1).join(' ').replace(/[ؐ-ًٖؕ-ٟۖ-ۭ]/g,''))+" ")])])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }